import { render } from "./DashboardUpdateUser.vue?vue&type=template&id=72bb4357&scoped=true"
import script from "./DashboardUpdateUser.vue?vue&type=script&lang=js"
export * from "./DashboardUpdateUser.vue?vue&type=script&lang=js"

import "./DashboardUpdateUser.vue?vue&type=style&index=0&id=72bb4357&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72bb4357"]])

export default __exports__